import { Typography } from "@mui/material";

import Modal from "../../../../../global/Modal";
import useAddCustomMedicalItemModal from "../../../hooks/useAddCustomMedicalItemModal";
import { SETTLEMENT_STYLES } from "../../../style/styles";
import SettlementActionButtons from "../../common/SettlementActionButtons";

import AddCustomMedicalItemForm from "./AddCustomMedicalItemForm";

export default function AddCustomMedicalItemModal(props) {
  const { openModal, handleCloseModal } = props;
  const {
    formValues,
    providerOptions,
    settlementTypeOptions,
    isDirty,
    hasChanges,
    isLoadingProviders,
    isSaving,
    handleFieldOnChange,
    handleProviderSearch,
    handleCancel,
    handleSave,
  } = useAddCustomMedicalItemModal(props);

  return (
    <Modal open={openModal} onClose={handleCloseModal} maxWidth="sm">
      <div>
        <div className="px-6 pt-6">
          <Typography className="text-[20px]" sx={SETTLEMENT_STYLES.modalTitle}>
            Add Custom Medical Item
          </Typography>
        </div>
        <AddCustomMedicalItemForm
          formValues={formValues}
          onChange={handleFieldOnChange}
          onProviderSearch={handleProviderSearch}
          providerOptions={providerOptions}
          settlementTypeOptions={settlementTypeOptions}
          isLoadingProviders={isLoadingProviders}
        />
        <div>
        <SettlementActionButtons
          disableCancel={!hasChanges || isSaving}
          disableSave={!isDirty || isSaving}
          handleOnClickCancelBtn={handleCancel}
          handleOnClickSaveButton={handleSave}
            saveLabel="Add"
          />
        </div>
      </div>
    </Modal>
  );
}
